'use client';
import LearnMore from '@components/LearnMore';
import { DrawerHeader, ModalID, useModal } from '@repo/ui/src/modules/UI';
import { Drawer } from '@repo/ui/src/modules/UI/components/Drawer';

const LearnMoreDrawer = () => {
  const { data } = useModal(ModalID.learnMore);

  return (
    <Drawer id={ModalID.learnMore} className="max-w-[500px]">
      <DrawerHeader />
      <LearnMore product={data} />
    </Drawer>
  );
};

export default LearnMoreDrawer;
